<template>
    <textarea v-bind="$attrs" ref="area"
      :class="classList"
      :rows="lines"
      :value="content.text"
      
      @input="resize"
      @mouseover="hoverOn"
      @mouseleave="hoverOff"
      @focus="focusOn"
      @blur="focusOff"
    >
    </textarea>
</template>





<script>
export default {
  name: 'default',
  props : {
    content: {
      type: Object,
      required: true,
    },
    styles: {
      type: String,
      default: ""
    },
  },
  emits : ['events'],
  data() {
    return {
      hover: false,
      focus: false,
    }
  },
  computed : {
    id() {
      return this.content?.id || ""
    },
    classList() {
      // Import & defaults
      let importOBJ = this.$styles.get(this.styles)
      let iAlign = importOBJ.align || "l"
      iAlign = "align-" + iAlign
      let iMain = importOBJ.main || "h"
      iMain = "main-" + iMain
      let iBg = importOBJ.bg || "0"
      iBg = "bg-" + iBg
      let iFont = importOBJ.font || "m"
      iFont = "font-" + iFont
      let iPad = importOBJ.pad  || "m"
      iPad = "pad-" + iPad
      let iPLeft = importOBJ.pleft  || "08"
      iPLeft = "pleft-" + iPLeft

      return ['component', 'border-none', iMain, iAlign, iBg, iFont, iPad, iPLeft]
    },
    lines() {
      let importOBJ = this.$styles.get(this.styles)
      let iLines = importOBJ.lines || "2"
      return iLines -1
    },
  },
  mounted() {
    this.$nextTick(function() {
        this.resize()
      })
  },
  methods : {
      resize() {
        let el = this.$refs.area
        el.style.height = "auto"
        el.style.height  = (el.scrollHeight +2) + "px"
      },
      hoverOn() {
        this.hover = true
        this.$emit('events', 'hoverOn', this.id)
        
      },
      hoverOff() {
        this.hover = false
        this.$emit('events', 'hoverOff', this.id)
      },
      focusOn() {
        this.focus = true
        this.$emit('events', 'focusOn', this.id)
      },
      focusOff() {
        this.focus = false
        this.$emit('events', 'focusOff', this.id)
      },
  },
}
</script>

<style scoped>
.component {
  width: 100%; /* width: 100%; needed for correct sizing */
  overflow : auto;
  resize : none;
}
</style>